type PageContainerProps = {
  children: React.ReactNode;
  /** Overrides the default 1400px cap — same convention as `PageTitle`'s `maxWidth` prop. */
  maxWidth?: string;
};

function PageContainer({ children, maxWidth }: PageContainerProps) {
  return (
    <div className="flex justify-center px-8 pt-8 pb-20">
      <div className="w-full" style={{ maxWidth: maxWidth ?? '1400px' }}>
        {children}
      </div>
    </div>
  );
}

export default PageContainer;
